import { Drawer, FloatButton, Popover } from "antd";
import {
    AppstoreOutlined,
    BgColorsOutlined,
    InfoCircleOutlined,
    LogoutOutlined,
    QuestionCircleOutlined,
    SearchOutlined
} from "@ant-design/icons";
import React, { useState } from "react";
import { SplitViewSettingsLayer } from "./SplitViewSettingsLayer";
import { SplitViewLayerSettingsHelp } from "./SplitViewLayerSettingsHelp";
import { SplitViewLayerSettingsColor } from "./SplitViewLayerSettingsColor";
import KeycloakService from "../core/keycloakService";
import { SplitViewSettingsStory } from "./SplitViewSettingsStory";
import { SingleLayerSettingsHelp } from "../singleLayer/SingleLayerSettingsHelp";
import { SingleLayerSettingsSearch } from "../singleLayer/SingleLayerSettingsSearch";

export function SplitViewSettings({
    idOne,
    idTwo,
    setIdTwo,
    dataOne,
    dataTwo,
    mapOneTheme,
    setMapOneTheme,
    mapTwoTheme,
    setMapTwoTheme,
    colorMaps,
    colorMapOneName,
    setColorMapOneName,
    colorMapOneOpacity,
    setColorMapOneOpacity,
    colorMapsTwo,
    colorMapTwoName,
    setColorMapTwoName,
    colorMapTwoOpacity,
    setColorMapTwoOpacity,
    data,
    viewState,
    setViewState
}) {
    const [openDrawer, setOpenDrawer] = useState(false);
    const [title, setTitle] = useState('');
    const [section, setSection] = useState(''); // ['layer', 'story', 'color']
    const toggleDrawer = (sectionNew) => {

        if (section === sectionNew && openDrawer === true) {
            setOpenDrawer(!openDrawer);
            setSection('')
        } else {
            if (openDrawer === false) {
                setOpenDrawer(!openDrawer);
            }

            setSection(sectionNew)
            switch (sectionNew) {
                case 'layer':
                    setTitle('Basemap')
                    break;
                case 'story':
                    setTitle('Story telling')
                    break;
                case 'color':
                    setTitle('Color map')
                    break;
                case 'menu':
                    setTitle('Select layer on right view')
                    break;
                case 'search':
                    setTitle('Search')
                default:
                    setTitle('')
            }
        }
    };
    const onDrawerClose = () => {
        setOpenDrawer(false);
        setSection('')
    };

    return (
        <>
            <FloatButton.Group
                shape="circle"
                style={{
                    top: 40,
                    right: openDrawer ? 540 : 40
                }}
            >
                <FloatButton
                    onClick={() => KeycloakService.logout()}
                    tooltip={<div>Logout</div>}
                    icon={<LogoutOutlined />}
                />
                <FloatButton
                    onClick={() => toggleDrawer('layer')}
                    tooltip={<div>Basemap</div>}
                    type={section === 'layer' ? 'primary' : 'default'}
                    icon={<AppstoreOutlined />}
                />
                <FloatButton
                    onClick={() => toggleDrawer('story')}
                    tooltip={<div>Story telling</div>}
                    type={section === 'story' ? 'primary' : 'default'}
                    icon={<InfoCircleOutlined />} />
                <FloatButton
                    onClick={() => toggleDrawer('color')}
                    type={section === 'color' ? 'primary' : 'default'}
                    tooltip={<div>Color map</div>}
                    icon={<BgColorsOutlined />} />
                <FloatButton
                    onClick={() => toggleDrawer('search')}
                    type={section === 'search' ? 'primary' : 'default'}
                    tooltip={<div>Search</div>}
                    icon={<SearchOutlined />} />
            </FloatButton.Group>

            <SplitViewLayerSettingsHelp
                dataOne={dataOne}
                dataTwo={dataTwo}
                colorMapOneName={colorMapOneName}
                colorMapTwoName={colorMapTwoName}
                openDrawer={openDrawer}
            />

            <Drawer title={title}
                width={500}
                placement="right"
                onClose={onDrawerClose}
                open={openDrawer}
                closeIcon={true}
                mask={false}
                maskClosable={false}>

                {section === 'layer' && <SplitViewSettingsLayer
                    mapOneTheme={mapOneTheme}
                    setOneMapTheme={setMapOneTheme}
                    mapTwoTheme={mapTwoTheme}
                    setMapTwoTheme={setMapTwoTheme}
                />}
                {section === 'story' && <SplitViewSettingsStory />}
                {section === 'color' && <SplitViewLayerSettingsColor
                    colorMaps={colorMaps}
                    colorMapOneName={colorMapOneName}
                    setColorMapOneName={setColorMapOneName}
                    colorMapOneOpacity={colorMapOneOpacity}
                    setColorMapOneOpacity={setColorMapOneOpacity}
                    colorMapsTwo={colorMapsTwo}
                    colorMapTwoName={colorMapTwoName}
                    setColorMapTwoName={setColorMapTwoName}
                    colorMapTwoOpacity={colorMapTwoOpacity}
                    setColorMapTwoOpacity={setColorMapTwoOpacity}
                    dataOne={dataOne}
                    dataTwo={dataTwo}
                />}
                {section === 'search' && <SingleLayerSettingsSearch
                    viewState={viewState}
                    setViewState={setViewState}
                    data={data}
                />}
            </Drawer>
        </>
    )
}